import { createStore } from 'vuex';
import auth from './auth';
import clientConfig from './clientConfig';

const store = createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    clientConfig
  }
});

export default store;
